import React, { useEffect } from 'react';
import { Heading, Spinner } from '@digitools/honest-react';
import { Breadcrumb, Breadcrumbs } from '@digitools/honest-ui';
import styles from './EOI.scss';
import { useAuth0, useLanguage } from 'status/hooks';
import useGet from '../../../../../hooks/useGet';
import titleCase from 'status/utilities/titleCase';
import EoiInfo from './EoiInfo';
import { useTranslation } from 'react-i18next';
import useTealium from '../../../../../hooks/useTealium';
import { TEALIUM_PAGE_VIEW } from '../../../../../constants/tealiumConstants';
import { CustomEmployeeText } from 'src/utils/CustomExperienceText';
import { Experience } from 'src/types/Experience';
import useExperience from 'src/hooks/useExperience';
import { useHomePageBreadcrumbs } from 'src/components/Breadcrumbs';
const EOI = () => {
    const { userMeta } = useAuth0();
    const { language } = useLanguage();
    const { t } = useTranslation();
    const { trackView } = useTealium();
    const { experience } = useExperience();
    const pageL4 = CustomEmployeeText(experience === Experience.EMPLOYEE ? 'employee view' : 'employer view');
    useEffect(() => {
        trackView({
            page_l3: TEALIUM_PAGE_VIEW.PAGE_L3.STATUS,
            page_l4: pageL4,
            page_l5: 'evidence of insurability'
        });
    }, []);
    const { error: eoiError, loading: loadingEoi, data: eoiData, } = useGet({
        url: '/status-service/eoi/status',
        options: {
            params: {
                languageCode: language,
            },
        },
    }, [language]);
    const loading = loadingEoi;
    if (loading) {
        return <Spinner id='eoi-spinner'/>;
    }
    const name = `${titleCase(userMeta.firstName)} ${titleCase(userMeta.lastName)}`;
    return (<div className={styles.container}>
      <div className='mb-4'>
        <Breadcrumbs>
          {useHomePageBreadcrumbs()}
          <Breadcrumb>{t('statusHeader')}</Breadcrumb>
        </Breadcrumbs>
        <Heading data-testid='status-header'>{t('statusHeader')}</Heading>
        <Heading elemType={'h2'} elemStyle={'h3'}>
          {t('eoiHeaderText')}
        </Heading>
        <Heading color={'primary'} elemType={'h3'}>
          {name}
        </Heading>
      </div>
      <EoiInfo eoi={eoiData} error={eoiError}/>
    </div>);
};
export default EOI;
